<template>
  <div :class="getColorClass">
    <p style="padding-left:10px" @click="getTodoList()">{{ personName }}</p>
    <a-modal :visible="modalVisible" :closable="false" :width="800" @cancel="closeModal">
      <a-table :width="700" :columns="columns" :data-source="combinedTasks">
        <span slot="taskTitle" slot-scope="text, record">
          <a-tooltip placement="top" :title="record.taskTitle">
            <a class="custom-link" :href="link(record)" target="_blank">{{ record.taskTitle }}</a>
          </a-tooltip>
        </span>
        <span slot="codingTask" slot-scope="text, record">
          <a-tag v-if="record.codingTask == 1" color="purple">{{ "编码任务" }}</a-tag>
          <a-tag v-if="record.codingTask == 0" color="orange">{{ "非编码任务" }}</a-tag>
        </span>
        <span slot="userName">
          {{ personName }}
        </span>
      </a-table>
      <div slot="footer" />
    </a-modal>
  </div>
</template>

<script>

export default {
  props: {
    personName: {
      type: String,
      default: ''
    },
    codingTask: {
      type: Array,
      default: null
    },
    uncodingTask: {
      type: Array,
      default: null
    }
  },

  data() {
    return {
      modalVisible: false,
      columns: [
        {
          title: '任务id',
          dataIndex: 'taskId',
          key: 'taskId',
          scopedSlots: { customRender: 'customKey' }
        },
        {
          title: '任务标题',
          dataIndex: 'taskTitle',
          width: 300,
          key: 'taskTitle',
          scopedSlots: { customRender: 'taskTitle' }
        },
        {
          title: '项目',
          dataIndex: 'projectName',
          width: 100,
          key: 'projectName',
          scopedSlots: { customRender: 'projectName' }
        },
        {
          title: '负责人',
          dataIndex: 'userName',
          width: 100,
          key: 'userName',
          scopedSlots: { customRender: 'userName' }
        },
        {
          title: '任务类型',
          dataIndex: 'codingTask',
          width: 100,
          key: 'codingTask',
          scopedSlots: { customRender: 'codingTask' }
        }
      ]
    };
  },
  computed: {
    getColorClass() {
      if (this.codingTask && this.uncodingTask && this.codingTask.length > 0 && this.uncodingTask.length > 0) {
        return 'purple-orange';
      } else if (this.codingTask && this.codingTask.length > 0) {
        return 'purple';
      } else if (this.uncodingTask && this.uncodingTask.length > 0) {
        return 'orange';
      } else {
        return '';
      }
    },
    link() {
      return record => {
        return record && record.project && record.taskId ? this.$router.resolve({ name: 'page:project:task:detail', query: { taskId: record.taskId }, params: { project_id: record.project }}).href : '';
      };
    },
    combinedTasks() {
      const value = (this.codingTask || []).concat(this.uncodingTask || []);
      return value;
    }
  },
  methods: {
    // 获取任务列表
    getTodoList() {
      this.modalVisible = true;
    },
    closeModal() {
      this.modalVisible = false;
    }
  }
};
</script>

  <style scoped>
  .purple {
    background-color: rgba(128, 50, 150, 0.5);
    color: white;
    border-radius: 6px;
  }

  .orange {
    background-color: orange;
    color: white;
    border-radius: 6px;
  }

  .purple-orange {
    background: linear-gradient(to right, rgba(128, 50, 150, 0.5) 50%, orange 50%);
    color: white;
    border-radius: 6px;
  }
  </style>
